// @flow
import * as React from 'react';
import { Modal, Header, Button } from 'semantic-grab-ui';
import { Steps } from 'antd';
import _ from 'lodash';
import { Icon } from 'grab-ui';
import './EntityStepFormModal.scss';

type StepProps = {
  name: string,
  component: React.Element,
};

type Props = {
  closeModal: Function,
  title: string,
  size: string,
  onStepChange: Function,
  mapStepComponent: { [key: number]: StepProps },
  onSaveDraft: Function,
  onCreate: Function,
  FormComponent: React.ElementType,
  formProps: any,
  isNextAllowedFn: Function,
  publishDisabled: boolean,
  saveDraftDisabled: boolean,
  publishLoading: boolean,
  saveDraftLoading: boolean,
  enableDraftButton: boolean,
};

export default class EntityStepFormModal extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      stepIndex: 0,
    };
  }

  nextStep = () => {
    const { onStepChange, isNextAllowedFn } = this.props;

    const { stepIndex } = this.state;
    const nextStep = stepIndex + 1;
    let isNextAllowed = true;
    if (isNextAllowedFn) {
      isNextAllowed = isNextAllowedFn(nextStep);
    }
    if (!isNextAllowed) {
      return;
    }
    this.setState(
      {
        stepIndex: nextStep,
      },
      () => {
        if (onStepChange) {
          onStepChange(nextStep);
        }
      },
    );
  };

  prevStep = () => {
    const { onStepChange } = this.props;
    const { stepIndex } = this.state;
    const prevStep = stepIndex - 1;
    if (prevStep + 1 > 0) {
      this.setState(
        {
          stepIndex: prevStep,
        },
        () => {
          if (onStepChange) {
            onStepChange(prevStep);
          }
        },
      );
    }
  };

  render() {
    const {
      closeModal,
      title,
      size,
      mapStepComponent,
      onSaveDraft,
      onCreate,
      FormComponent,
      formProps,
      publishDisabled,
      saveDraftDisabled,
      publishLoading,
      saveDraftLoading,
      enableDraftButton,
    } = this.props;
    const { stepIndex } = this.state;
    const isLastStep = mapStepComponent.length - 1 === stepIndex;
    return (
      <Modal
        className={'ucd-basic'}
        size={size}
        open
        style={{ padding: '36px 36px 24px' }}
      >
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Header as="h2">{title}</Header>
          </div>
          <div>
            <Icon onClick={closeModal} color={'#707070'} type="close" />
          </div>
        </div>
        <div style={{ marginTop: 38 }} />
        <Steps size={size} current={stepIndex}>
          {_.map(mapStepComponent, (val, idx) => {
            return (
              <Steps.Step
                title={val.name}
                icon={
                  stepIndex > idx ? (
                    <Icon type="check-circle" theme="filled" />
                  ) : null
                }
              />
            );
          })}
        </Steps>
        <Modal.Content style={{ padding: 0 }}>
          <FormComponent {...formProps}>
            {_.map(mapStepComponent, (val, index) => {
              const StepComp = val.component;
              return (
                <div style={stepIndex === index ? {} : { display: 'none' }}>
                  {StepComp}
                </div>
              );
            })}
          </FormComponent>
        </Modal.Content>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: '100%',
              }}
              className={'back-icon-button-color'}
              onClick={stepIndex === 0 ? () => {} : this.prevStep}
            >
              {stepIndex !== 0 && (
                <React.Fragment>
                  <div style={{ height: 18, paddingTop: 1 }}>
                    <Icon type="arrow-left" />
                  </div>
                  <div style={{ height: 18 }}>&nbsp;Back</div>
                </React.Fragment>
              )}
            </div>
          </div>
          <div>
            {(isLastStep && enableDraftButton) && (
              <Button
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E5E5E5',
                  boxSizing: 'border-box',
                  borderRadius: '6px',
                  fontWeight: 'bold',
                  marginRight: 8,
                }}
                disabled={saveDraftDisabled}
                className={'button-save-draft'}
                onClick={onSaveDraft}
                loading={saveDraftLoading}
              >
                Save as draft
              </Button>
            )}
            {isLastStep ? (
              <Button
                disabled={publishDisabled}
                className="entity-save-btn"
                primary={!publishDisabled}
                onClick={onCreate}
                loading={publishLoading}
              >
                Publish
              </Button>
            ) : (
              <Button
                className="entity-save-btn"
                primary
                onClick={this.nextStep}
              >
                Next
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}
